import {formatString} from '@optimaxdev/utils';

export const TYP_CONTACT_LENSES = {
    action: 'Contact Lenses',
    category: formatString('TYP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_INFO_BLOCK = {
    action: formatString('{{blockName}}'),
    category: formatString('TYP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_RX_DETAILS = {
    action: 'Update Rx Details',
    category: formatString('TYP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_REVIEW_POPUP = {
    action: 'Review pop-up',
    category: 'TYP',
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_RATE_US = {
    action: 'Rate Us',
    category: 'TYP',
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_SMS_SUBSCRIPTION = {
    action: 'SMS Subscription',
    category: formatString('TYP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_CTA = {
    action: 'CTA',
    category: formatString('TYP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_TYP_FORM_ACTION = {
    action: "Doctor's Details",
    category: formatString('TYP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_SMS_POPUP = {
    action: 'Contact Lenses SMS PopUp',
    category: formatString('TYP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_MENTION_ME = {
    action: 'MentionMe',
    category: formatString('TYP'),
    label: formatString('MentionMe - {{label}}'),
    name: 'TYP',
};

export const TYP_ORDER_CONFIRMATION = {
    action: 'Order Confirmation',
    category: formatString('TYP'),
    label: formatString('CTA - {{label}} - Clicked'),
    name: 'TYP',
};

export const TYP_SEE_DETAILS = {
    action: 'See Details',
    category: formatString('TYP'),
    label: formatString('CTA - {{label}} - Clicked'),
    name: 'TYP',
};

export const TYP_BOTTOM_SECTION = {
    action: formatString('{{action}}'),
    category: formatString('TYP'),
    label: formatString('{{label}}'),
    name: 'TYP',
};

export const TYP_COUPON_DETAILS = {
    action: 'Coupon Details',
    category: 'TYP',
    label: 'Tooltip - Clicked',
    name: 'TYP',
};

export const TYP_COUPON_DETAILS_CLICK = {
    action: 'Popup Coupon',
    category: 'TYP',
    label: 'Copy Code - Clicked',
    name: 'TYP',
};

export const TYP_ORDER_CONFIRMATION_CLICK = {
    action: 'Order Confirmation',
    category: 'TYP',
    label: 'CTA - Shop Now - Clicked',
    name: 'TYP',
};
